import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { environment } from 'src/environments/environment';
import { QueryProcessorService } from 'src/app/services/query-services/query-processor.service';

@Component({
  selector: 'app-globalsearchcomponent',
  templateUrl: './globalsearchcomponent.component.html',
  styleUrls: ['./globalsearchcomponent.component.scss'],
})
export class GlobalsearchcomponentComponent {
  userRole: any;
  departmentId: any;
  globalSearchStatus: boolean;
  @Output() componentSelection = new EventEmitter<any>();

  constructor(private elementRef: ElementRef, private formBuilder: FormBuilder, private httpClient: HttpClient, private _standardUiService: StandardUIService, private QueryProcessorService: QueryProcessorService) {

  }
  srrrrrr: any = []




  selectedImage: string | ArrayBuffer | null = null;

  openswal() {
    // const container = this.elementRef.nativeElement.querySelector('.swal2-container');
    // if (container) {
    //   container.classList.add('custom-icon'); // Add your custom class to the container
    // }

    // Swal.fire({
    //   title: 'Custom Title',
    //   text: 'This dialog has a custom emoji in the top left corner.',
    //   icon: 'info',
    //   showCloseButton: true,
    //   showCancelButton: true,
    //   focusConfirm: false,
    //   confirmButtonText: `
    //     <i class="fa fa-thumbs-up"></i> Great!
    //   `,
    //   confirmButtonAriaLabel: 'Thumbs up, great!',
    //   cancelButtonText: `
    //     <i class="fa fa-thumbs-down"></i>
    //   `,
    //   cancelButtonAriaLabel: 'Thumbs down'
    // });

    Swal.fire({
      title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class=animated-check >This dialog has the specified image in the top left corner.</div></div>',
      icon: 'info',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
imageHeight: 45,
showCloseButton: true,
      
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `
        Done
      `,
      confirmButtonAriaLabel: 'Thumbs up, great!'
    });
  }
  globalsearchletter: any = ''
  casesubtypeVal: any = [];
  departmentVal: any = []
  casetypeVal: any = [];
  servicerequest_source: any = []
  addresstypeVal: any = []
  associatedareaVal: any = []
  servicerequestcreatedby: any = []
  statusVal: any = []

  globalsearchform: FormGroup;
  loadAllUsers() {
    const payload = {
      "entityName": "suser"
    }
    this.httpClient.post(environment.apiURL + 'gquery', payload).subscribe((data: any) => {
      console.log(data)
      this.servicerequestcreatedby = data.payLoad
    })
  }

  contactsearchfilters: any = []
  answersearchfilters: any = []
  SRsearchfilters: any = []

  extractActiveKeys(obj: any): string[] {
    const keys: any = '';
    for (const key in obj) {
      if (key.startsWith('key_') && obj[key].active === true) {
        return keys?.split('_')[1];
      }
    }
    // return keys;
  }
  getObjectValues(obj: any): any[] {
    // return Object.keys(obj).map(key => obj[key]);

    return Object.keys(obj)
      .filter(key => obj[key].active === true);
  }


  // getObjectKeys(picklistvaluesv1: any): string[] {
  //   // console.log(picklistvaluesv1);
  //   const activeKeys: string[] = [];
  //   // console.log(this.userRole)
  //   if(this.userRole == 'Department'){
  //     $(".unit-search").addClass("dept-show");
  //     for (const key in picklistvaluesv1) {
  //       if(this.departmentId == this.getSplitValue(key) ){
  //         console.log(this.userRole,this.departmentId,key)
  //         activeKeys.push(key);
  //         break;
  //       }
  //     }

  //   }else{
  //     for (const key in picklistvaluesv1) {
  //       if (picklistvaluesv1[key].active) {

  //         activeKeys.push(key);

  //       }
  //     } 
  //   }

  //   return activeKeys;
  // }

  getObjectKeys(obj: any): string[] {
    // Extract active keys, sort them alphabetically, and return

    if (this.userRole === 'Department') {
      const departmentKeys: string[] = [];
      for (const key in obj) {
        if (this.departmentId === this.getSplitValue(key)) {
          console.log(this.userRole, this.departmentId, key);
          departmentKeys.push(key);
          break; // Assuming you only want one key if userRole is 'Department'
        }
      }
      return departmentKeys;
    }
    else {
      return Object.keys(obj)
        .filter(key => obj[key].active) // Filter only active keys
        .sort((a, b) => obj[a].value.localeCompare(obj[b].value)); // Sort by value alphabetically
    }
  }

  getSplitValue(key: string): string {
    return key.split('_')[1];
  }

  extractKey(key: string): string {
    return key?.split('_')[1]; // Assuming key is always in the format "key_XXX"
  }

  loadallfilters() {
    // contact search :3
    // answer search :4
    // service request search :2
    // Global search :5

    const filtersID = [2, 3, 4];
    filtersID.forEach(filterid => {
      this.QueryProcessorService.getQueriesService(filterid).subscribe(data => {
        console.log(data)
        var filterlistValues = []
        filterlistValues = data.filter(item => (item.hidden == false || item.hidden == '' || item.hidden == null));

        // const filterlistValues = [];
        // for (let key in data) {
        //   if (data[key].hidden == false || data[key].hidden == '') {
        //     filterlistValues.push({
        //       "id": data[key].id,
        //       "sequenceOrder": data[key].sequenceOrder,
        //       "inputName": data[key].inputName,
        //       "dataType": data[key].dataType,
        //       "defaultValue": data[key].defaultValue,
        //       "placeHolder": data[key].placeHolder,
        //       "hidden": data[key].valueen,
        //       "objectName": data[key].valueen,
        //       "columnName": data[key].valueen,
        //       "label": data[key].valueen,
        //       "operator": data[key].valueen,
        //       "pickListValues": data[key].valueen,
        //       "picklistvaluesv1": data[key].valueen,
        //       "value": data[key].valueen,
        //       "query": data[key].valueen
        //     });
        //   }
        // }
        if (filterid == 2) {
          // filterlistValues.forEach(item=>
          //   {
          //     item.
          //   }
          // )
          this.SRsearchfilters.push(...filterlistValues)
          console.log(this.SRsearchfilters)
        }
        else if (filterid == 3) {
          this.contactsearchfilters.push(...filterlistValues)
          console.log(this.contactsearchfilters)
        }
        else if (filterid == 4) {
          this.answersearchfilters.push(...filterlistValues)
          console.log(this.answersearchfilters)
        }
        // console.log(this.answersearchfilters, this, this.SRsearchfilters, this.contactsearchfilters)
      })

    })
  }

  // display() {
  //   console.log(this.contactsearchfilters)
  // }
  ngOnInit() {
    this.departmentId = localStorage.getItem("locationid")
    this.userRole = localStorage.getItem("role")
    console.log(this.userRole, this.departmentId);
    this.loadallfilters()
    this.loadAllUsers()
    this.picklist();
    $('#dropdown_click_close').trigger('click')
    this.globalsearchform = this.formBuilder.group({
      selectedOption: ['contactSearchForm'],
      contactSearchForm: this.formBuilder.group({
        lastname: ['', Validators.required],
        firstname: ['', Validators.required],
        phonenumber: ['', Validators.required],
        email: ['', Validators.email],
        street: [],
        postalcode: []
      }),

      answerSearchForm: this.formBuilder.group({
        summary: ['', Validators.required],
        answerid: ['', Validators.required],
        // associatedarea: ['', Validators.required],
        keywords: ['', Validators.required]
      }),

      incidentSearchForm: this.formBuilder.group({
        refno: ['', Validators.required],
        createdby: ['', Validators.required],
        incidentstatus: ['', Validators.required],
        department: ['', Validators.required],
        casetype: ['', Validators.required],
        casesubtype: ['', Validators.required],
        addresstype: ['', Validators.required],
        addressline1: ['', Validators.required],
        // addressline2: [''],
        customerfirstname: ['', Validators.required],
        customerlastname: ['', Validators.required],
        createdstart: ['', Validators.required],
        createdend: ['', Validators.required],
        servicerequestsource: ['', Validators.required],
      })
    })

  }

  displaysr() {
    console.log(this.SRsearchfilters)
  }

  picklist() {
    const picklistIDs = [40, 110, 20, 95, 98, 108, 140]; // Array of picklist IDs
    picklistIDs.forEach(picklistID => {
      this._standardUiService.getPicklistByID(picklistID).subscribe(data => {
        // console.log(data)
        const picklistValues = [];
        for (let key in data) {
          if (data[key].active === true || data[key].active === '') {
            picklistValues.push({
              "id": data[key].id,
              "value": data[key].valueen
            });
          }
        }
        if (picklistID == 40) {
          this.casesubtypeVal.push(...picklistValues);
          // console.log(this.casesubtypeVal)
        }
        else if (picklistID == 110) {
          this.casetypeVal.push(...picklistValues);
          // console.log(this.casetypeVal)
        }
        else if (picklistID == 20) {
          this.departmentVal.push(...picklistValues);
          // console.log(this.departmentVal)
        }
        else if (picklistID == 95) {
          this.servicerequest_source.push(...picklistValues);
          // console.log(this.servicerequest_source)
        }
        else if (picklistID == 98) {
          this.addresstypeVal.push(...picklistValues);
          // console.log(this.addresstypeVal)
        }
        else if (picklistID == 108) {
          this.associatedareaVal.push(...picklistValues);
          // console.log(this.addresstypeVal)
        }
        else if (picklistID == 140) {
          const filteredValues = picklistValues.filter(value => value.id !== 8 && value.id !== 102);
          this.statusVal.push(...filteredValues);
          // this.statusVal.push(...picklistValues);
          // console.log(this.addresstypeVal)
        }
      });
    });
  }

  converttoepoch(date: any) {
    const dateObject = new Date(date);

    // Get the Epoch time (in milliseconds) using getTime() method
    const epochTimeMilliseconds = dateObject.getTime();

    // Convert milliseconds to seconds (Epoch time is usually represented in seconds)
    const epochTimeSeconds = Math.floor(epochTimeMilliseconds / 1000);

    console.log(epochTimeSeconds);
    return epochTimeSeconds
  }
  checkGlobalSearchStatus() {
    console.log(this.globalsearchletter.length > 0)
    if (this.globalsearchletter.length > 0) {
      this.globalSearchStatus = false;
    }
    // else{
    // this.globalSearchStatus= true;
    // }
  }
  oncomponentSelection(componentData) {
    //console.log(componentData.letter.trim());
    if(componentData.letter && componentData.letter.trim() != ''){
      componentData.letter = componentData.letter.trim();
    }
    console.log(componentData)

    // if(this.globalsearchletter.length>0){
    this.globalSearchStatus = false;
    if (componentData.type == 'query' && componentData.id != '5') {
      this.globalsearchletter = ''
      // $('#dropdown_click_close').trigger('click')
      const selectedOption = this.globalsearchform?.get('selectedOption')?.value;

      if (selectedOption === 'contactSearchForm') {
        const phonenumber = this.globalsearchform.get(['contactSearchForm', 'phonenumber'])
        console.log(this.globalsearchform.get('contactSearchForm').value)
        if (!(phonenumber.value == null || phonenumber.value == '' || phonenumber.value == undefined)) {
          this.globalsearchform.get(['contactSearchForm', 'phonenumber']).setValue(phonenumber.value.replaceAll(/[^0-9]/g, ''))
        }

        const address = this.globalsearchform.get(['contactSearchForm', 'street'])
        if (!(address.value == null || address.value == '' || address.value == undefined)) {
          this.globalsearchform.get(['contactSearchForm', 'street']).setValue(address.value.replaceAll(/[^a-zA-Z0-9]/g, ''))
        }

        componentData.advanceSearch = this.globalsearchform.get('contactSearchForm').value

        console.log(this.globalsearchform.get('contactSearchForm').value)
        componentData.id = 3
        componentData.name = 'Contact Search'
        componentData.src = '../../assets/images/Profile.svg'

      } else if (selectedOption === 'answerSearchForm') {
        componentData.advanceSearch = this.globalsearchform.get('answerSearchForm').value
        console.log(this.globalsearchform.get('answerSearchForm').value)
        componentData.id = 4
        componentData.name = 'Answer Search'
        componentData.src = '../../assets/images/existinganswer.svg'
      } else {
        const createdstart = this.globalsearchform.get(['incidentSearchForm', 'createdstart'])
        const createdend = this.globalsearchform.get(['incidentSearchForm', 'createdend'])
        if (!(createdstart.value == null || createdstart.value == '' || createdstart.value == undefined)) {
          this.converttoepoch(createdstart.value)
          this.globalsearchform.get(['incidentSearchForm', 'createdstart'])?.setValue(this.converttoepoch(createdstart.value))
        }
        if (!(createdend.value == null || createdend.value == '' || createdend.value == undefined)) {
          this.converttoepoch(createdend.value)
          this.globalsearchform.get(['incidentSearchForm', 'createdend'])?.setValue(this.converttoepoch(createdend.value))

        }
        componentData.advanceSearch = this.globalsearchform.get('incidentSearchForm').value
        console.log(this.globalsearchform.get('incidentSearchForm').value)
        this.globalsearchform.get('incidentSearchForm').value

        componentData.id = 2
        componentData.name = 'Service Request Search'
        componentData.src = '../../assets/images/existingservicerequest.svg'
      }

    }
    else {
      this.globalSearchStatus = true;
    }

    this.componentSelection.emit(componentData)
    this.clearglobalsearchform()
    // }
    // else{
    //   this.globalSearchStatus= true;
    // }

  }

  clearglobalsearchform() {
    console.log("in clear")
    const selectedvalue = this.globalsearchform?.get('selectedOption')?.value
    this.globalsearchform?.reset()
    // alert(selectedvalue)
    this.globalsearchform?.get('selectedOption').setValue(selectedvalue)
    this.globalsearchform?.get(['answerSearchForm', 'associatedarea'])?.setValue('')
    this.globalsearchform?.get(['incidentSearchForm', 'createdby'])?.setValue('')
    this.globalsearchform?.get(['incidentSearchForm', 'department'])?.setValue('')
    this.globalsearchform?.get(['incidentSearchForm', 'casetype'])?.setValue('')
    this.globalsearchform?.get(['incidentSearchForm', 'casesubtype'])?.setValue('')
    this.globalsearchform?.get(['incidentSearchForm', 'addresstype'])?.setValue('')
    this.globalsearchform?.get(['incidentSearchForm', 'servicerequestsource'])?.setValue('')
    this.globalsearchform?.get(['incidentSearchForm', 'incidentstatus'])?.setValue('')
    $('[data-link-id]').removeClass('link-active');
  }

}